import { c as _c } from "react/compiler-runtime";
import { Box, VStack, Separator } from '@chakra-ui/react';
import { ArticleHero } from '@src/components/sco/Education/ArticleLanding/ArticleHero';
import { ArticleListCarousel } from '@src/components/sco/Education/ArticleLanding/ArticleListCarousel';
import { FounderInterviewList } from '@src/components/sco/Education/ArticleLanding/FounderInterviewList';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import ContentIntro from '@src/components/sco/Education/Other/ContentIntro';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import React from 'react';
type ArticleLandingProps = {
  articleType: 'ExpertAdvice' | 'FounderStory' | 'BlogPost';
  typeTitle?: string;
  typeSlug?: string;
};
export const ArticleLanding: React.FC<ArticleLandingProps> = props => {
  const $ = _c(19);
  const educationContext = useEducationContext();
  const typeTitle = props.typeTitle || "Articles";
  const typeSlug = props.typeSlug || "articles";
  let t0;
  if ($[0] !== educationContext || $[1] !== typeSlug || $[2] !== typeTitle) {
    t0 = () => {
      educationContext.setActiveSection(`${typeSlug}.landing`);
      educationContext.setBreadcrumbs([{
        title: typeTitle,
        href: `/${typeSlug}`
      }]);
    };
    $[0] = educationContext;
    $[1] = typeSlug;
    $[2] = typeTitle;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useUniversalEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["featured"];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.articleType) {
    t3 = <ArticleHero articleType={props.articleType} termSlugs={t2} />;
    $[6] = props.articleType;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== educationContext.activeSection || $[9] !== props.articleType) {
    t4 = educationContext.activeSection === "articles.landing" && <VStack align="flex-start" width="full"><ContentIntro description="Hand-curated advice from startup Founders on every aspect of starting a company." title="Expert Advice" /><VStack align="flex-start" gap={5} width="full"><Box paddingX={10} paddingY={8} width="full"><ArticleListCarousel articleType={props.articleType} term="funding" /></Box><Separator borderColor="colorPalette.border" /><Box paddingX={10} paddingY={8} width="full"><ArticleListCarousel articleType={props.articleType} term="idea-validation" /></Box><Separator borderColor="colorPalette.border" /><Box paddingX={10} paddingY={8} width="full"><ArticleListCarousel articleType={props.articleType} term="pitch-deck" /></Box><Separator borderColor="colorPalette.border" /><Box paddingX={10} paddingY={8} width="full"><ArticleListCarousel articleType={props.articleType} term="product-mvp" /></Box></VStack></VStack>;
    $[8] = educationContext.activeSection;
    $[9] = props.articleType;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== educationContext.activeSection || $[12] !== typeSlug || $[13] !== typeTitle) {
    t5 = educationContext.activeSection === "founder-interviews.landing" && <VStack align="flex-start" maxWidth="container.xl" width="full"><ContentIntro description="Personal, candid interviews with the most world-changing Founders of all time." title="Origin Stories of Legendary Founders" /><Box paddingX={10} paddingY={8} width="full"><FounderInterviewList typeSlug={typeSlug} typeTitle={typeTitle} /></Box></VStack>;
    $[11] = educationContext.activeSection;
    $[12] = typeSlug;
    $[13] = typeTitle;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <VStack align="center" gap={10} justify="stretch" marginBottom={20} width="full">{t3}{t4}{t5}</VStack>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};